import { Collection, TextInput, MultilineInput, Rate } from "@tblabs/truffle";
import { Opinion } from "../../../Models/Description/Opinion/Opinion";
import { CollectionItemPrinter } from "../../Utils/CollectionItemPrinter";
import { FormRow, FormPrinter } from "../../../Pages/Product/InputsPrinter";


export class OpinionEdit extends CollectionItemPrinter<Opinion>
{
    constructor(opinion: Opinion, opinions: Collection<Opinion>)
    {
        super(opinion, opinions);

        this.AddContent(
            new FormPrinter([
                new FormRow("Autor", new TextInput(opinion.Author).Placeholder("Autor").WidthPercent(40).FloatLeft()),
                new FormRow("Ocena", new Rate(opinion.Rate, { SelectedSymbol: "⭐", DeselectedSymbol: "⭐", DeselectedStyle: "opacity: 0.4" }).FloatLeft()),
                new FormRow("Komentarz", new MultilineInput(opinion.Comment).Rows(4).Placeholder("Komentarz")),
                new FormRow("Zalety", new TextInput(opinion.Advantages).Placeholder("Zalety")),
                new FormRow("Wady", new TextInput(opinion.Disadvantages).Placeholder("Wady")),
            ]),
        )
    }
}
